var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import rotService from "@/core/services/rotService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Acoes_CorretivasActions } from "@/store/enums/rotEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Acoes_CorretivasModule = class Acoes_CorretivasModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Acoes_CorretivasActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            rotService.getFile("Acoes_Corretivas/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Acoes_Corretivas.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Acoes_CorretivasActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            rotService.postFile("Acoes_Corretivas/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Acoes_CorretivasActions.POST_ACOES_CORRETIVAS](data) {
        return new Promise(resolve => {
            rotService.post("Acoes_Corretivas/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Acoes_CorretivasActions.PUT_ACOES_CORRETIVAS](data) {
        return new Promise(resolve => {
            rotService.put("Acoes_Corretivas/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Acoes_CorretivasActions.DELETE_ACOES_CORRETIVAS](data) {
        return new Promise(resolve => {
            rotService.delete("Acoes_Corretivas/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Acoes_CorretivasActions.DELETE_RANGE_ACOES_CORRETIVAS](data) {
        return new Promise(resolve => {
            rotService.delete("Acoes_Corretivas/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Acoes_CorretivasActions.FILTER_ACOES_CORRETIVAS](data) {
        return new Promise(resolve => {
            rotService.post("Acoes_Corretivas/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Acoes_CorretivasActions.GET_ACOES_CORRETIVAS]() {
        return new Promise(resolve => {
            rotService.get("Acoes_Corretivas/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Acoes_CorretivasActions.GETWITHDISABLED_ACOES_CORRETIVAS]() {
        return new Promise(resolve => {
            rotService.get("Acoes_Corretivas/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Acoes_CorretivasActions.GET_BY_ID_ACOES_CORRETIVAS](data) {
        return new Promise(resolve => {
            rotService.get("Acoes_Corretivas/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Acoes_CorretivasModule.prototype, _k, null);
Acoes_CorretivasModule = __decorate([
    Module
], Acoes_CorretivasModule);
export default Acoes_CorretivasModule;
//********** COMENTÁRIO GERADO EM: 18/06/2025 09:27:37 **********
//
//import rotService from "@/core/services/rotService";
//import JwtService from "@/core/services/JwtService";
//import { Mutations } from "@/store/enums/StoreEnums";
//import {Acoes_CorretivasActions} from "@/store/enums/rotEnums";
//import {Module, Action, VuexModule} from "vuex-module-decorators";
//
//
//@Module
//export default class Acoes_CorretivasModule extends VuexModule {
//    errors = {};
//    isAuthenticated = !!JwtService.getToken();
//    
//	@Action
//    [Acoes_CorretivasActions.DOWNLOAD_PLANILHA]() {
//        return new Promise((resolve, reject) => {
//            rotService.getFile("Acoes_Corretivas/DownloadPlanilhaModelo")
//                .then((response) => {
//                    const blob = new Blob([response.data], {
//                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                    });
//
//                    const url = window.URL.createObjectURL(blob);
//                    const link = document.createElement('a');
//                    link.href = url;
//                    link.setAttribute('download', 'Planilha_Modelo_Acoes_Corretivas.xlsx');
//                    document.body.appendChild(link);
//                    link.click();
//                    document.body.removeChild(link);
//
//                    resolve(response);
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors);
//                    } else {
//                        reject("Erro ao baixar a planilha.");
//                    }
//                });
//        });
//    }
//
//	 @Action
//    [Acoes_CorretivasActions.UPLOAD_PLANILHA](file: File) {
//        const formData = new FormData();
//        formData.append('file', file); // Adiciona o arquivo ao FormData
//
//        return new Promise((resolve, reject) => {
//            rotService.postFile("Acoes_Corretivas/ImportarPlanilha", formData)
//                .then(({ data }) => {
//                    resolve(data); // Sucesso
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors); // Rejeita com o erro
//                    } else {
//                        reject("Erro ao enviar a planilha.");
//                    }
//                });
//        });
//    }
//
//    @Action
//    [Acoes_CorretivasActions.POST_ACOES_CORRETIVAS] (data) {
//        return new Promise(resolve => {
//			rotService.post("Acoes_Corretivas/Post", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//
//	@Action
//	[Acoes_CorretivasActions.PUT_ACOES_CORRETIVAS] (data) {
//        return new Promise(resolve => {
//            rotService.put("Acoes_Corretivas/Put", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Acoes_CorretivasActions.DELETE_ACOES_CORRETIVAS](data) {
//        return new Promise(resolve => {
//            rotService.delete("Acoes_Corretivas/Delete", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Acoes_CorretivasActions.DELETE_RANGE_ACOES_CORRETIVAS](data) {
//        return new Promise(resolve => {
//            rotService.delete("Acoes_Corretivas/DeleteRange", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Acoes_CorretivasActions.FILTER_ACOES_CORRETIVAS](data) {
//        return new Promise(resolve => {
//            rotService.post("Acoes_Corretivas/Filter", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Acoes_CorretivasActions.GET_ACOES_CORRETIVAS]() {
//        return new Promise(resolve => {
//            rotService.get("Acoes_Corretivas/Get")
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//    [Acoes_CorretivasActions.GETWITHDISABLED_ACOES_CORRETIVAS]() {
//        return new Promise(resolve => {
//            rotService.get("Acoes_Corretivas/GetWithDisabled")
//				  .then(({ data }) => {
//				resolve(data);
//			})
//                .catch (({ response }) => {
//				this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Acoes_CorretivasActions.GET_BY_ID_ACOES_CORRETIVAS](data) {
//        return new Promise(resolve => {
//            rotService.get("Acoes_Corretivas/GetById", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//}
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=Acoes_CorretivasModule.js.map